import React from "react";
const Contact = () => {
  return (
    <div className=" text-center  ">
      <h1 className="  text-4xl p-6">Contact</h1>
      <div className=" flex justify-center items-center p-14  ">
        <div>
          <div className="w-56 text-justify  text-3xl">
            <p className="  ">Feel free to connect with me or reach out.</p>
            </div>
            <p className="text-xl">Get in touch anytime.</p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
